import React from 'react';

import './key-item-platform.styles.scss';


export default function KeyItemPlatform({ platforms }) {
    const PLATFORMS = {
        'platform::vr': 'fa fa-vr-cardboard',
        'platform::android': 'mfa fa-android text-android',
        'platform::ios': 'fab fa-apple',
        'platform::web': 'fas fa-globe',
        'platform::marketing': 'fas fa-bullhorn',
    };

    return (
        <div className="d-inline">
            {Object.entries(PLATFORMS).map(([platform, icon], index) =>
                (
                    <span key={index} className={`key-item-platform ${platforms.includes(platform) ? "text-light-blue" : "transparent"}`}>
                        <i className={`${icon}`} />
                    </span>
                )
            )}

        </div>
    )

}